const OVERVIEW = '/overview';

export const ROUTE_HOME_OVERVIEW = OVERVIEW + '/home';

export const overviewRoutes = [ROUTE_HOME_OVERVIEW];
